exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-28b89fda]{max-height:600px;overflow-y:auto}.content-title[data-v-28b89fda]{gap:20px;display:flex;align-items:center}.media[data-v-28b89fda]{align-items:center}.media-content[data-v-28b89fda]{max-width:100%;overflow:hidden}.tag[data-v-28b89fda]{font-weight:600}.tag-full[data-v-28b89fda]{width:70%}.tag .icon[data-v-28b89fda]{margin-right:1.1875em!important}.modal-card[data-v-28b89fda]{max-height:90vh;overflow-y:auto}.m-auto[data-v-28b89fda]{margin:auto}.text-truncate[data-v-28b89fda]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}@media screen and (max-width:768px){.table-container[data-v-28b89fda]{max-height:400px}.columns[data-v-28b89fda]{flex-direction:column}.buttons[data-v-28b89fda]{justify-content:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28b89fda","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/logs/Logs.vue
// module id = 1028
// module chunks = 2